import { render, staticRenderFns } from "./MaterialsInfo.vue?vue&type=template&id=3e87bb41&scoped=true"
import script from "./MaterialsInfo.vue?vue&type=script&lang=js"
export * from "./MaterialsInfo.vue?vue&type=script&lang=js"
import style0 from "./MaterialsInfo.vue?vue&type=style&index=0&id=3e87bb41&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e87bb41",
  null
  
)

export default component.exports